module.exports = __webpack_public_path__ + "static/media/mmonkcolor.9816ea3f.jpg";